import request from '@/utils/request'

/**
 * 获取树形列表
 */
export const getBuildingLists = (data) => {
    return request({
        url: '/building/lists',
        params: data
    })
}

// 获取房间类型管理选项列表
export const getRoomTypeOptionLists = (data) => {
    return request({
        url: '/room/type/option/lists',
        params: data
    })
}

/**
 * 获取楼 层 选项列表
 */
export const getBuildingOptionLists = (data) => {
    return request({
        url: '/building/option/lists',
        params: data
    })
}
/**
 * 获取树形列表tree
 */
export const getBuildingTree = (data) => {
    return request({
        url: '/building/tree',
        params: data
    })
}

export const batchFloor = (data) => {
    return request({
        url: '/building/batch/floor',
        method: 'POST',
        data
    })
}

/**
 *  获取楼层选项Tree
 */
export const getBuildingTreeOption = (data) => {
    return request({
        url: '/building/option/tree',
        params: data
    })
}

/**
 * 获取带房间的树形列表
 */
// export const getRoomTreeLists = (data) => {
//     return request({
//         url: '/room/tree/lists',
//         params: data
//     })
// }
/**
 * 楼层区域管理-添加楼
 */
export const addBuilding = (data) => {
    return request({
        url: '/building/manage',
        method: 'POST',
        data
    })
}
/**
 * 楼层区域管理-删除
 */
export const delBuilding = (id) => {
    return request({
        url: `/building/${id}`,
        method: 'DELETE'
    })
}
/**
 * 楼层区域管理-批量删除
 */
export const areaBatchDelete = (data) => {
    return request({
        url: '/building/batch/delete',
        method: 'POST',
        data
    })
}

/**
 * 楼层区域管理-详情
 */
export const getBuildingDetail = (id) => {
    return request({
        url: `/building/${id}`
    })
}
/**
 * 楼层区域管理-编辑
 */
export const putBuilding = (data) => {
    return request({
        url: '/building/manage',
        method: 'PUT',
        data
    })
}
/**
 * 房间管理-添加房间
 */
export const addRooming = (data) => {
    return request({
        url: '/room/manage',
        method: 'POST',
        data
    })
}
/**
 * 获取房间 列表
 */
export const getRoomLists = (data) => {
    return request({
        url: '/room/lists',
        params: data
    })
}
/**
 * 房间管理-删除
 */
export const delRoom = (id) => {
    return request({
        url: `/room/${id}`,
        method: 'DELETE'
    })
}
/**
 * 房间管理-批量删除
 */
export const roomBatchDelete = (data) => {
    return request({
        url: '/room/batch/delete',
        method: 'POST',
        data
    })
}

/**
 * 房间管理-详情
 */
export const getRoomDetail = (id) => {
    return request({
        url: `/room/${id}`
    })
}

/**
 * 筛选房间树
 */
export const getRoomOptions = (id, out_class = 0, in_room = '') => {
    return request({
        url: '/room/option/lists',
        params: { building: id, out_class, in_room }
    })
}

// 筛选房间列表
export const getRoomFilterOptionLists = (id, only_room = 0, only_module = '', in_room = '') => {
    return request({
        url: '/room/option/lists',
        params: { building: id, only_room, only_module, in_room }
    })
}
/**
 * 筛选房间树
 */
export const getRoomParamsOptions = (data) => {
    return request({
        url: '/room/option/lists',
        params: data
    })
}

/**
 * 房间管理-详情
 */
export const putRooming = (data) => {
    return request({
        url: '/room/manage',
        method: 'PUT',
        data
    })
}

/**
 * 批量排序
 * @param {*} module 导入模块类型
 */
export const batchSort = (module, data) => {
    return request({
        url: `/${module}/manage`,
        method: 'PATCH',
        data: {
            method: 'batch_update_order',
            data
        }
    })
}

// 批量启用
export const batchEnable = (data) => {
    return request({
        url: '/room/manage',
        method: 'PATCH',
        data: {
            method: 'batch_enable',
            data
        }
    })
}

// 批量禁用
export const batchDisable = (data) => {
    return request({
        url: '/room/manage',
        method: 'PATCH',
        data: {
            method: 'batch_disable',
            data
        }
    })
}
/**
 * 批量处理
 * batch_update_order 更新排序
 * batch_enable 批量启用
 * batch_disable 批量禁用
 * batch_display 批量显示
 * batch_hidden 批量隐藏
 */
export const batchPatch = (method, data) => {
    return request({
        url: '/room/manage',
        method: 'PATCH',
        data: {
            method,
            data
        }
    })
}

/** 同步浙大宿舍列表**/
export const syncDormAreaDataList = () => {
    return request({
        url: '/dorm/area/lists/sync',
        method: 'POST'
    })
}
/** 设置户主**/
export const setHousehold = (data) => {
    return request({
        url: '/room/household/manage',
        method: 'POST',
        data
    })
}
/** 充值**/
export const recharge = (data) => {
    return request({
        url: '/household/recharge',
        method: 'POST',
        data
    })
}
/** 设置风机盘管运行功率 **/
export const setFCUPower = (data) => {
    return request({
        url: '/building/FCU/power',
        method: 'POST',
        data
    })
}
